/*
 * Table runner designer, a Shopify theme section (sections/table-runner-designer.liquid).
 * Reads its data from <script type="application/json" data-trd-config> written by the section
 * and renders everything into [data-trd-app].
 * Designs come from the "runner_design" metaobject entries; built-in designs fill in if none are set up.
 * Cart: in "event" mode each fabric is added as one continuous Measura cut (see measuraLine).
 * Holiday chips and tag search: section settings "Holiday chips" and "Holiday selected when the page opens",
 * or a link such as ?holiday=christmas.
 * Rebuilt 2026-09-28.
 */
(function () {
  'use strict';

  // ===================== shared designer core =====================
  // Same code in all three design tools (quilt, table runner, bag). Only the prefix differs.
  var FR = ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'];
  var SVGNS = 'http://www.w3.org/2000/svg';
  var SEAM = 'rgba(20,20,20,.28)';
  var MONO = 'font-family="ui-monospace, Menlo, monospace"';
  var LABEL = 'fill="rgba(240,232,160,.85)" ' + MONO + ' text-anchor="middle"';
  var TAG_FAMILY = {
    white: 'light', cream: 'light', ivory: 'light', tan: 'brown', brown: 'brown', beige: 'brown',
    reds: 'red', red: 'red', pink: 'red', orange: 'orange', peaches: 'orange', peach: 'orange', rust: 'orange',
    gold: 'gold', yellow: 'gold', greens: 'green', green: 'green', blues: 'blue', blue: 'blue', teal: 'blue',
    purple: 'purple', black: 'grey', grey: 'grey', gray: 'grey', multi: 'print'
  };
  var FAMILIES = [
    ['all', 'All', null], ['light', 'Whites & creams', '#f3efe4'], ['brown', 'Tans & browns', '#9b7650'],
    ['red', 'Reds & pinks', '#c83a3a'], ['orange', 'Oranges', '#ee8a4a'], ['gold', 'Golds & yellows', '#e5c05a'],
    ['green', 'Greens', '#8fb77a'], ['blue', 'Blues', '#3d5f9a'], ['purple', 'Purples', '#8b7bc4'],
    ['grey', 'Greys & blacks', '#7d7f80'], ['print', 'Multi & prints', '#555'], ['solid', 'Solids only', null]
  ];
  var DEFAULT_HOLIDAYS = "Valentine's Day = holiday_valentines\nEaster = holiday_easter\nFourth of July = holiday_patriotic\nThanksgiving = holiday_thanksgiving\nChristmas = holiday_christmas";

  // ---------- helpers ----------
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtYd(y, step) {
    step = step || 8;
    var e = Math.max(1, Math.ceil(y * step - 1e-9)) * (8 / step);
    var w = Math.floor(e / 8), f = e % 8;
    return (w ? w + (f ? ' ' : '') : '') + FR[f] + ' yd';
  }
  function inch(v) { // 1.25 → 1¼″
    var w = Math.floor(v + 1e-9), f = Math.round((v - w) * 8);
    return (w ? String(w) : '') + FR[f] + '″';
  }
  function formatMoney(cents, format) {
    format = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    function fmt(n, dec, thou, decSep) {
      var fixed = (n / 100).toFixed(dec).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return whole + (dec ? decSep + fixed[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2, ',', '.');
      }
    });
  }
  function area(p) {
    var a = 0;
    for (var i = 0; i < p.length; i++) {
      var q = p[i], r = p[(i + 1) % p.length];
      a += q[0] * r[1] - r[0] * q[1];
    }
    return Math.abs(a) / 2;
  }
  // Finished piece grown by the seam allowance on every side (mitered corners).
  function cutArea(p, d) {
    d = d == null ? 0.25 : d;
    var per = 0, cot = 0, n = p.length;
    for (var i = 0; i < n; i++) {
      var a = p[(i + n - 1) % n], b = p[i], c = p[(i + 1) % n];
      per += Math.hypot(c[0] - b[0], c[1] - b[1]);
      var v1 = [a[0] - b[0], a[1] - b[1]], v2 = [c[0] - b[0], c[1] - b[1]];
      var cos = (v1[0] * v2[0] + v1[1] * v2[1]) / (Math.hypot(v1[0], v1[1]) * Math.hypot(v2[0], v2[1]));
      var th = Math.acos(Math.max(-1, Math.min(1, cos)));
      cot += 1 / Math.tan(th / 2);
    }
    return area(p) + per * d + d * d * cot;
  }
  function centroid(p) {
    var x = 0, y = 0;
    p.forEach(function (q) { x += q[0]; y += q[1]; });
    return [x / p.length, y / p.length];
  }
  function pathD(p) {
    return 'M' + p.map(function (q) { return q[0] + ' ' + q[1]; }).join('L') + 'Z';
  }
  function rectP(x, y, w, h) { return [[x, y], [x + w, y], [x + w, y + h], [x, y + h]]; }
  function b64urlEncode(obj) {
    var s = btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    return s.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(s) {
    try {
      s = s.replace(/-/g, '+').replace(/_/g, '/');
      while (s.length % 4) s += '=';
      return JSON.parse(decodeURIComponent(escape(atob(s))));
    } catch (e) { return null; }
  }
  // "Andover Century Solids" → "Century Solids" when the vendor is Andover.
  function stripMaker(title, vendor) {
    title = String(title || '');
    if (vendor && title.toLowerCase().indexOf(String(vendor).toLowerCase() + ' ') === 0) {
      var rest = title.slice(String(vendor).length + 1).replace(/^[\s\-–—:·]+/, '');
      if (rest) return rest;
    }
    return title;
  }
  // For search and holiday links: lower case, no apostrophes.
  function norm(s) { return String(s || '').toLowerCase().replace(/['’‘`]/g, ''); }
  function slug(s) { return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function parseJson(v) {
    if (v == null || v === '') return null;
    if (typeof v === 'object') return v;
    try { return JSON.parse(v); } catch (e) { return null; }
  }
  // Slots may be [{id,name,role}] or [[id,name,role]].
  function normSlots(list) {
    if (!Array.isArray(list)) return null;
    var out = list.map(function (s) {
      if (Array.isArray(s)) return { id: String(s[0]), name: s[1] || String(s[0]), role: s[2] || 'any' };
      if (s && s.id) return { id: String(s.id), name: s.name || String(s.id), role: s.role || 'any' };
      return null;
    });
    return out.every(Boolean) && out.length ? out : null;
  }
  function validPieces(list) {
    return Array.isArray(list) && list.length && list.every(function (pc) {
      return pc && pc.s && Array.isArray(pc.p) && pc.p.length >= 3;
    });
  }
  // Holiday chips: one per line, "Chip name = tag".
  function parseHolidays(text) {
    var seen = {};
    return String(text == null ? DEFAULT_HOLIDAYS : text).split(/\r?\n/).map(function (line) {
      var i = line.lastIndexOf('=');
      if (i < 1) return null;
      var name = line.slice(0, i).trim(), tag = line.slice(i + 1).trim().toLowerCase();
      if (!name || !tag || seen[tag]) return null;
      seen[tag] = true;
      return { name: name, tag: tag };
    }).filter(Boolean);
  }

  function prepFabrics(raw, cfg) {
    var perYard = cfg.cartMode === 'quarter_units' ? 4 : 1;
    return (raw || []).filter(function (f) { return f && f.available && f.variantId; }).map(function (f) {
      var tags = (f.tags || []).map(function (t) { return String(t).toLowerCase(); });
      var fam = null;
      tags.forEach(function (t) {
        if (!fam && t.indexOf('color_') === 0) fam = TAG_FAMILY[t.slice(6)] || null;
      });
      if (!fam && tags.some(function (t) { return /^theme_/.test(t); })) fam = 'print';
      var img = f.image ? (f.image.indexOf('//') === 0 ? 'https:' + f.image : f.image) : null;
      return {
        key: String(f.id),
        sku: f.sku || '',
        name: stripMaker(f.title, f.vendor),
        vendor: f.vendor || '',
        url: f.url,
        variantId: f.variantId,
        pricePerYard: (f.price || 0) * perYard, // cents
        img: img,
        tags: tags,
        sw: Math.max(1, parseFloat(f.swatchWidth) || parseFloat(cfg.defaultSwatchWidth) || 6),
        fam: fam || 'print',
        solid: /\bsolids?\b/i.test(f.title),
        tracked: !!f.tracked,
        stockYards: f.tracked ? Math.max(0, f.stock || 0) / perYard : Infinity
      };
    });
  }

  // ---------- the component ----------
  // spec = what makes this designer a quilt / runner / bag designer (see the bottom of the file).
  function Designer(root, spec) {
    var cfgEl = root.querySelector('[data-trd-config]');
    this.spec = spec;
    this.root = root;
    this.app = root.querySelector('[data-trd-app]');
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) {
      this.app.innerHTML = '<p class="trd-loading">The ' + spec.noun + ' designer couldn’t read its settings.</p>';
      return;
    }
    this.sid = String(this.cfg.sectionId || Math.random().toString(36).slice(2)).replace(/[^\w-]/g, '');
    this.fabrics = prepFabrics(this.cfg.fabrics, this.cfg);
    this.designs = this.prepDesigns(this.cfg.designs);
    this.byKey = {};
    this.bySku = {};
    var self = this;
    this.fabrics.forEach(function (f) { self.byKey[f.key] = f; if (f.sku) self.bySku[f.sku.toUpperCase()] = f; });
    var present = {};
    this.fabrics.forEach(function (f) { f.tags.forEach(function (t) { present[t] = true; }); });
    this.holidays = parseHolidays(this.cfg.holidayChips).filter(function (h) { return present[h.tag]; });
    this.fabrics.forEach(function (f) {
      var hol = self.holidays.filter(function (h) { return f.tags.indexOf(h.tag) > -1; }).map(function (h) { return h.name; });
      f.hay = norm([f.name, f.vendor, f.sku, f.tags.join(' '), hol.join(' ')].join(' '));
    });
    if (spec.setup) spec.setup.call(this);

    if (!this.fabrics.length || !this.designs.length) {
      this.app.innerHTML = '<p class="trd-loading">' + (!this.designs.length
        ? 'No ' + spec.noun + ' designs have been set up yet.'
        : 'No fabrics are available for the designer right now.') + '</p>';
      return;
    }
    this.patterns = {};
    this.state = this.initialState();
    this.applyUrlState();
    this.buildShell();
    this.bind();
    this.renderAll();
  }
  var P = Designer.prototype;

  // Designs from the metaobject entries; built-in ones fill any gaps (and stand in when none are set up).
  P.prepDesigns = function (raw) {
    var spec = this.spec, cfg = this.cfg, out = [], used = {};
    (raw || []).forEach(function (d) {
      if (!d) return;
      var g = parseJson(d.geometry), dflt = parseJson(d.defaults) || {};
      var builtin = spec.builtin.filter(function (b) {
        return b.id === d.id || slug(b.name) === slug(d.name) || (b.aliases || []).indexOf(d.id) > -1;
      })[0];
      var des = spec.prepGeometry(g) || (builtin && spec.prepGeometry(builtin.geometry));
      if (!des) return;
      des.id = String(d.id || slug(d.name));
      des.name = d.name || (builtin && builtin.name) || des.id;
      des.skill = d.skill || (builtin && builtin.skill) || '';
      des.sort = Number(d.sort) || 0;
      des.defaults = {};
      Object.keys((builtin && builtin.defaults) || {}).forEach(function (k) { des.defaults[k] = builtin.defaults[k]; });
      Object.keys(dflt).forEach(function (k) { des.defaults[k] = dflt[k]; });
      if (builtin) used[builtin.id] = true;
      out.push(des);
    });
    if (!out.length && cfg.builtinFallback !== false) {
      spec.builtin.forEach(function (b, i) {
        var des = spec.prepGeometry(b.geometry);
        des.id = b.id; des.name = b.name; des.skill = b.skill || ''; des.sort = i + 1; des.defaults = b.defaults || {};
        out.push(des);
      });
    }
    return out.sort(function (a, b) { return a.sort - b.sort; });
  };

  P.design = function () {
    var id = this.state.design;
    return this.designs.filter(function (d) { return d.id === id; })[0] || this.designs[0];
  };
  P.pickFabric = function (role, i) {
    var pool = this.fabrics.filter(function (f) {
      return role === 'light' ? f.fam === 'light' : role === 'dark' ? /blue|purple|grey|brown|green/.test(f.fam) : f.fam !== 'light';
    });
    if (!pool.length) pool = this.fabrics;
    return pool[i % pool.length].key;
  };
  P.skuKey = function (sku) {
    var f = sku && this.bySku[String(sku).toUpperCase()];
    return f ? f.key : null;
  };
  P.designDefaults = function (d) {
    var self = this, out = {};
    d.slots.forEach(function (s, i) { out[s.id] = self.skuKey(d.defaults[s.id]) || self.pickFabric(s.role, i * 7 + 3); });
    return out;
  };
  // Finishing parts: design default (_border etc.), then the spec's fallback SKU, then a design fabric.
  P.finishDefaults = function (d, f0) {
    var self = this, out = {}, slots = d.slots;
    var light = slots.filter(function (s) { return s.role === 'light'; })[0] || slots[0];
    var dark = slots.filter(function (s) { return s.role === 'dark'; })[0] || slots[slots.length - 1];
    var second = slots[1] || slots[0];
    var pick = { light: light, dark: dark, second: second };
    this.spec.qslots.forEach(function (q) {
      out[q.id] = self.skuKey(d.defaults['_' + q.id]) || self.skuKey(q.sku) || f0[(pick[q.from] || second).id];
    });
    return out;
  };
  P.optDefault = function (o) {
    var v = this.cfg[o.cfgKey || ('default_' + o.id)];
    return o.values.indexOf(String(v)) > -1 ? String(v) : String(o.dflt);
  };
  P.initialState = function () {
    var self = this, cfg = this.cfg, spec = this.spec;
    var first = this.designs.filter(function (d) { return d.id === cfg.defaultDesign; })[0] || this.designs[0];
    var fab = {}, opt = {};
    this.designs.forEach(function (d) { fab[d.id] = self.designDefaults(d); });
    this.options().forEach(function (o) { opt[o.id] = self.optDefault(o); });
    var views = spec.views.map(function (v) { return v[0]; });
    var hol = this.findHoliday(cfg.holidayDefault);
    return {
      design: first.id,
      view: views.indexOf(cfg.defaultView) > -1 ? cfg.defaultView : spec.defaultView,
      opt: opt,
      fab: fab,
      q: this.finishDefaults(first, fab[first.id]),
      active: 'b:' + (first.slots[1] || first.slots[0]).id,
      hover: null, fam: 'all', hol: hol ? hol.tag : '', query: ''
    };
  };
  P.options = function () {
    var self = this;
    return this.spec.options.filter(function (o) { return !o.show || o.show.call(self); }).map(function (o) {
      var opts = typeof o.opts === 'function' ? o.opts.call(self) : o.opts;
      return { id: o.id, label: o.label, opts: opts, values: opts.map(function (x) { return String(x[0]); }), dflt: o.dflt, cfgKey: o.cfgKey, group: o.group };
    });
  };
  P.opt = function (id) { return this.state.opt[id]; };
  // "christmas", "holiday_christmas", "fourth-of-july" or "Fourth of July" all find the chip.
  P.findHoliday = function (v) {
    var s = slug(v);
    if (!s) return null;
    return this.holidays.filter(function (h) {
      var t = slug(h.tag);
      return t === s || t.replace(/^holiday-/, '') === s || slug(h.name) === s;
    })[0] || null;
  };

  // ---------- shareable URL ----------
  P.urlState = function () {
    var s = this.state, d = this.design();
    var o = { d: d.id, v: s.view, o: s.opt, f: s.fab[d.id], q: s.q };
    if (s.hol) o.y = s.hol;
    return o;
  };
  P.applyUrlState = function () {
    var params, raw, s = this.state, self = this;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    var h = this.findHoliday(params.get('holiday'));
    if (h) s.hol = h.tag;
    raw = params.get(this.spec.param);
    if (!raw) return;
    var o = b64urlDecode(raw);
    if (!o) return;
    var d = this.designs.filter(function (x) { return x.id === o.d; })[0];
    if (!d) return;
    s.design = d.id;
    if (this.spec.views.some(function (v) { return v[0] === o.v; })) s.view = o.v;
    if (o.o) this.options().forEach(function (op) { if (op.values.indexOf(String(o.o[op.id])) > -1) s.opt[op.id] = String(o.o[op.id]); });
    var ok = function (k) { return k && self.byKey[k]; };
    if (o.f) d.slots.forEach(function (sl) { if (ok(o.f[sl.id])) s.fab[d.id][sl.id] = o.f[sl.id]; });
    if (o.q) this.spec.qslots.forEach(function (q) { if (ok(o.q[q.id])) s.q[q.id] = o.q[q.id]; });
    if (o.y) { var hy = this.findHoliday(o.y); if (hy) s.hol = hy.tag; }
    s.active = 'b:' + (d.slots[1] || d.slots[0]).id;
  };
  P.shareUrl = function () {
    var u = new URL(window.location.href);
    u.searchParams.delete('holiday');
    u.searchParams.set(this.spec.param, b64urlEncode(this.urlState()));
    return u.toString();
  };
  P.syncUrl = function () {
    try { window.history.replaceState(window.history.state, '', this.shareUrl()); } catch (e) { /* ignore */ }
  };

  // ---------- lookups ----------
  P.keyFor = function (slotKey) {
    var s = this.state;
    if (s.hover && slotKey === s.active) return s.hover;
    return this.storedKey(slotKey);
  };
  P.storedKey = function (slotKey) {
    var parts = slotKey.split(':');
    return parts[0] === 'b' ? this.state.fab[this.design().id][parts[1]] : this.state.q[parts[1]];
  };
  P.slotEnabled = function (k) {
    var p = k.split(':');
    if (p[0] === 'b') return true;
    var q = this.spec.qslots.filter(function (x) { return x.id === p[1]; })[0];
    return !q || !q.on || q.on.call(this);
  };
  P.slotName = function (k) {
    var p = k.split(':');
    if (p[0] === 'b') return (this.design().slots.filter(function (s) { return s.id === p[1]; })[0] || {}).name;
    return (this.spec.qslots.filter(function (s) { return s.id === p[1]; })[0] || {}).name;
  };
  P.money = function (cents) { return formatMoney(Math.round(cents), this.cfg.moneyFormat); };
  P.dims = function () { return this.spec.dims.call(this); };

  // Yardage: the spec adds pieces with put(); this rounds each fabric up.
  P.yardage = function () {
    var self = this, s = this.state;
    var WOF = Number(this.cfg.usableWidth) || 40, waste = 1 + (Number(this.cfg.wastePercent) || 0) / 100;
    var raw = {}, perSlot = {}, uses = {};
    function put(slotKey, yd) {
      if (!(yd > 0)) return;
      var key = self.storedKey(slotKey);
      raw[key] = (raw[key] || 0) + yd;
      perSlot[slotKey] = (perSlot[slotKey] || 0) + yd;
      var nm = self.slotName(slotKey);
      (uses[key] = uses[key] || []).indexOf(nm) < 0 && uses[key].push(nm);
    }
    // n rectangles (cut size w × h): rows across the fabric width, whichever way round uses less.
    function rects(w, h, n) {
      function rows(a, b) { if (a > WOF) return Infinity; return Math.ceil(n / Math.floor(WOF / a)) * b; }
      var r = Math.min(rows(w, h), rows(h, w));
      if (r === Infinity) r = n * Math.ceil(w / WOF) * h; // wider than the fabric: pieced
      return r / 36;
    }
    // Strips cut across the width of fabric for a total length (border, binding, sashing).
    function strips(totalLen, cutW) { return Math.ceil(totalLen / WOF - 1e-9) * cutW / 36; }
    // Pieced parts: sum of cut areas, plus the trimming allowance.
    function pieced(slotKey, cutAreaSqIn) { put(slotKey, cutAreaSqIn * waste / (WOF * 36)); }
    this.spec.yardage.call(this, { put: put, rects: rects, strips: strips, pieced: pieced, WOF: WOF, waste: waste });
    var whole = this.cfg.cartMode === 'yards';
    var buy = {};
    Object.keys(raw).forEach(function (k) {
      buy[k] = whole ? Math.max(1, Math.ceil(raw[k] - 1e-9)) : Math.max(0.25, Math.ceil(raw[k] * 4 - 1e-9) / 4);
    });
    return { buy: buy, perSlot: perSlot, uses: uses };
  };
  P.shortages = function (buy) {
    if (!this.cfg.showStock) return [];
    var self = this;
    return Object.keys(buy).filter(function (k) { return buy[k] > self.byKey[k].stockYards; });
  };

  // ---------- SVG helpers ----------
  P.pid = function (key) { return 'trd-' + this.sid + '-p-' + key; };
  P.ensurePattern = function (key) {
    if (this.patterns[key]) return;
    var f = this.byKey[key];
    if (!f) return;
    var W = f.sw, T = 2 * W;
    var p = document.createElementNS(SVGNS, 'pattern');
    p.setAttribute('id', this.pid(key));
    p.setAttribute('patternUnits', 'userSpaceOnUse');
    p.setAttribute('width', T);
    p.setAttribute('height', T);
    var html = '<rect width="' + T + '" height="' + T + '" fill="#c9c9c4"/>';
    if (f.img) {
      // Four mirrored copies hide the seams where the photo repeats.
      ['', 'translate(' + T + ' 0) scale(-1 1)', 'translate(0 ' + T + ') scale(1 -1)', 'translate(' + T + ' ' + T + ') scale(-1 -1)']
        .forEach(function (t) {
          html += '<image href="' + esc(f.img) + '" x="0" y="0" width="' + W + '" height="' + W + '" preserveAspectRatio="xMidYMid slice"' + (t ? ' transform="' + t + '"' : '') + '/>';
        });
    }
    p.innerHTML = html;
    this.defs.appendChild(p);
    this.patterns[key] = true;
  };
  P.fill = function (key) {
    this.ensurePattern(key);
    return 'url(#' + this.pid(key) + ')';
  };
  P.selStroke = function (sw) { return 'fill="none" stroke="var(--trd-thread)" stroke-width="' + sw + '" stroke-dasharray=".4 .25" pointer-events="none"'; };
  // Pieces of one unit at (tx, ty); rot = quarter turns about the unit's center.
  P.piecesSVG = function (pieces, tx, ty, opts) {
    opts = opts || {};
    var self = this, o = '', sel = '', act = this.state.active;
    var tr = 'translate(' + tx + ' ' + ty + ')' + (opts.rot ? ' rotate(' + 90 * opts.rot + ' ' + opts.cx + ' ' + opts.cy + ')' : '');
    pieces.forEach(function (pc) {
      var k = 'b:' + pc.s, key = opts.fabOf ? opts.fabOf(pc.s) : self.keyFor(k);
      o += '<path d="' + pathD(pc.p) + '" fill="' + self.fill(key) + '" stroke="' + SEAM + '" stroke-width="' + (opts.seam || 0.04) + '"' + (opts.click ? ' data-slot="' + k + '"' : '') + '/>';
      if (opts.click && k === act) sel += '<path d="' + pathD(pc.p) + '" ' + self.selStroke(opts.selW || 0.1) + '/>';
    });
    return { body: '<g transform="' + tr + '">' + o + '</g>', sel: sel ? '<g transform="' + tr + '">' + sel + '</g>' : '' };
  };
  P.badge = function (x, y, n, r) {
    return '<g pointer-events="none"><circle cx="' + x + '" cy="' + y + '" r="' + r + '" fill="#fff" stroke="#17211e" stroke-width="' + r * 0.12 + '"/><text x="' + x + '" y="' + (y + r * 0.36) + '" font-size="' + r * 1.05 + '" font-weight="700" text-anchor="middle" fill="#17211e" ' + MONO + '>' + n + '</text></g>';
  };
  P.matGrid = function (x0, y0, x1, y1, step, major) {
    var g = '', x, y, w = step * 0.035, W = step * 0.06;
    for (x = Math.ceil(x0 / step) * step; x <= x1; x += step) {
      var mx = Math.abs(x % major) < 1e-6;
      g += '<line x1="' + x + '" y1="' + y0 + '" x2="' + x + '" y2="' + y1 + '" stroke="' + (mx ? 'rgba(236,226,146,.5)' : 'rgba(255,255,255,.1)') + '" stroke-width="' + (mx ? W : w) + '"/>';
    }
    for (y = Math.ceil(y0 / step) * step; y <= y1; y += step) {
      var my = Math.abs(y % major) < 1e-6;
      g += '<line x1="' + x0 + '" y1="' + y + '" x2="' + x1 + '" y2="' + y + '" stroke="' + (my ? 'rgba(236,226,146,.5)' : 'rgba(255,255,255,.1)') + '" stroke-width="' + (my ? W : w) + '"/>';
    }
    return g;
  };
  P.mat = function (X0, Y0, VW, VH, step, major) {
    return '<rect x="' + (X0 - 60) + '" y="' + (Y0 - 60) + '" width="' + (VW + 120) + '" height="' + (VH + 120) + '" fill="var(--trd-mat)"/>' +
      this.matGrid(X0 - 60, Y0 - 60, X0 + VW + 60, Y0 + VH + 60, step, major);
  };

  // ---------- DOM ----------
  P.q = function (sel) { return this.app.querySelector(sel); };
  P.buildShell = function () {
    var id = this.sid, spec = this.spec, self = this;
    var controls = this.options().map(function (o) {
      var opts = '', groups = {};
      o.opts.forEach(function (x) {
        var html = '<option value="' + esc(x[0]) + '">' + esc(x[1]) + '</option>';
        if (x[2]) { if (!groups[x[2]]) { groups[x[2]] = []; } groups[x[2]].push(html); } else opts += html;
      });
      Object.keys(groups).forEach(function (g) { opts += '<optgroup label="' + esc(g) + '">' + groups[g].join('') + '</optgroup>'; });
      return '<label for="trd-' + o.id + '-' + id + '">' + esc(o.label) + '<select id="trd-' + o.id + '-' + id + '" data-trd-opt="' + o.id + '">' + opts + '</select></label>';
    }).join('');
    this.app.innerHTML =
      '<svg class="trd-defs" width="0" height="0" aria-hidden="true" focusable="false"><defs data-trd-defs></defs></svg>' +
      '<div class="trd-card trd-stage">' +
        '<div class="trd-blocks" data-trd-blocks role="group" aria-label="' + esc(spec.designsLabel) + '"></div>' +
        '<div class="trd-bar">' +
          '<div class="trd-seg" role="group" aria-label="View">' +
            spec.views.map(function (v) { return '<button type="button" data-trd-view="' + v[0] + '">' + esc(v[1]) + '</button>'; }).join('') +
          '</div>' +
          '<div class="trd-muted" data-trd-size></div>' +
        '</div>' +
        '<div class="trd-canvas" data-trd-canvas></div>' +
        '<div class="trd-controls" style="--trd-cols:' + Math.min(6, this.options().length) + '">' + controls + '</div>' +
        '<p class="trd-hint">' + esc(spec.hint) + '</p>' +
      '</div>' +
      '<div class="trd-layout">' +
        '<div class="trd-card trd-sec">' +
          '<div class="trd-sec-h"><h3 class="trd-h" data-trd-slots-title></h3>' +
            '<div class="trd-tools"><button type="button" class="trd-ghost" data-trd-surprise>Surprise me</button><button type="button" class="trd-ghost" data-trd-reset>Reset</button></div></div>' +
          '<div class="trd-slots" data-trd-slots></div>' +
          '<p class="trd-sub">' + esc(spec.qTitle) + '</p>' +
          '<div class="trd-slots" data-trd-qslots></div>' +
          '<div class="trd-picker">' +
            '<p class="trd-picker-h" data-trd-picker-h></p>' +
            '<label class="trd-visually-hidden" for="trd-search-' + id + '">Search fabrics</label>' +
            '<input class="trd-search" id="trd-search-' + id + '" type="search" placeholder="Search by name, maker, SKU or holiday" autocomplete="off" data-trd-search>' +
            '<div class="trd-chips" data-trd-chips role="group" aria-label="Filter by color"></div>' +
            '<div class="trd-hol" data-trd-hol-row' + (this.holidays.length ? '' : ' hidden') + '><span class="trd-hol-l">Holidays</span><div class="trd-chips" data-trd-hols role="group" aria-label="Filter by holiday"></div></div>' +
            '<div class="trd-grid" data-trd-grid></div>' +
          '</div>' +
        '</div>' +
        '<div class="trd-card trd-sec">' +
          '<div class="trd-sec-h"><h3 class="trd-h">Shopping list</h3><span class="trd-muted" data-trd-list-for></span></div>' +
          '<table class="trd-list"><tbody data-trd-list></tbody></table>' +
          '<div class="trd-totals"><span class="trd-muted" data-trd-tot-yd></span><span class="trd-big" data-trd-tot></span></div>' +
          '<div class="trd-warn" data-trd-warn hidden></div>' +
          '<button type="button" class="trd-cta" data-trd-add>Add all to cart</button>' +
          '<div class="trd-msg" data-trd-msg role="status" aria-live="polite" hidden></div>' +
          '<button type="button" class="trd-ghost trd-share" data-trd-share>Copy link to this design</button>' +
          '<p class="trd-note" data-trd-extra hidden></p>' +
          '<p class="trd-fine" data-trd-fine></p>' +
        '</div>' +
      '</div>';
    this.defs = this.q('[data-trd-defs]');
    this.buildGrid();
  };
  P.buildGrid = function () {
    var self = this, present = {};
    this.fabrics.forEach(function (f) { present[f.fam] = true; if (f.solid) present.solid = true; });
    this.q('[data-trd-chips]').innerHTML = FAMILIES.filter(function (x) { return x[0] === 'all' || present[x[0]]; }).map(function (x) {
      return '<button type="button" class="trd-chip" data-trd-fam="' + x[0] + '">' + (x[2] ? '<i style="background:' + x[2] + '"></i>' : '') + esc(x[1]) + '</button>';
    }).join('');
    this.q('[data-trd-hols]').innerHTML = this.holidays.map(function (h) {
      return '<button type="button" class="trd-chip" data-trd-holiday="' + esc(h.tag) + '">' + esc(h.name) + '</button>';
    }).join('');
    this.q('[data-trd-grid]').innerHTML = this.fabrics.map(function (f) {
      var low = self.cfg.showStock && f.tracked && f.stockYards < 3;
      return '<button type="button" class="trd-fab" data-trd-fabric="' + f.key + '" title="' + esc(f.name + (f.vendor ? ' by ' + f.vendor : '') + (f.sku ? ' · ' + f.sku : '')) + '">' +
        '<span class="trd-sw"' + (f.img ? ' style="background-image:url(\'' + esc(f.img) + '\')"' : '') + '></span>' +
        '<b>' + esc(f.name) + '</b><small>' + self.money(f.pricePerYard) + '/yd' + (low ? ' · ' + fmtYd(f.stockYards, 4) + ' left' : '') + '</small></button>';
    }).join('') + '<p class="trd-empty" data-trd-nohits hidden>No fabrics match. Try another color or holiday, or clear the search.</p>';
  };
  P.swatch = function (key, cls) {
    var f = this.byKey[key];
    return '<span class="' + cls + '"' + (f && f.img ? ' style="background-image:url(\'' + esc(f.img) + '\')"' : '') + '></span>';
  };
  P.renderBlocks = function () {
    var self = this, cur = this.design().id;
    this.q('[data-trd-blocks]').innerHTML = this.designs.map(function (d) {
      return '<button type="button" class="trd-blk" data-trd-design="' + esc(d.id) + '" aria-pressed="' + (d.id === cur) + '">' + self.spec.miniSVG.call(self, d) +
        '<span>' + esc(d.name) + '</span>' + (d.skill ? '<small>' + esc(d.skill) + '</small>' : '') + '</button>';
    }).join('');
  };
  P.renderStage = function () {
    this.q('[data-trd-canvas]').innerHTML = this.spec.render.call(this, this.state.view);
  };
  P.renderSlots = function () {
    var self = this, des = this.design(), y = this.yardage(), s = this.state;
    this.q('[data-trd-slots-title]').textContent = des.name + ' fabrics';
    this.q('[data-trd-slots]').innerHTML = des.slots.map(function (sl, i) {
      var k = 'b:' + sl.id, f = self.byKey[s.fab[des.id][sl.id]];
      return '<button type="button" class="trd-slot" data-trd-slot="' + k + '" aria-pressed="' + (k === s.active) + '"><span class="trd-num">' + (i + 1) + '</span>' + self.swatch(f.key, 'trd-sw') +
        '<span class="trd-t"><strong>' + esc(sl.name) + '</strong><small>' + esc(f.name) + (f.vendor ? ' · ' + esc(f.vendor) : '') + '</small></span><span class="trd-yd">' + fmtYd(y.perSlot[k] || 0) + '</span></button>';
    }).join('');
    this.q('[data-trd-qslots]').innerHTML = this.spec.qslots.map(function (qs) {
      var k = 'q:' + qs.id, f = self.byKey[s.q[qs.id]], en = self.slotEnabled(k);
      var sub = en ? esc(f.name) + (f.vendor ? ' · ' + esc(f.vendor) : '') : esc(qs.off || 'Not used');
      return '<button type="button" class="trd-slot" data-trd-slot="' + k + '" aria-pressed="' + (k === s.active) + '"' + (en ? '' : ' disabled') + '><span class="trd-num trd-num--q">' + esc(qs.name[0]) + '</span>' + self.swatch(f.key, 'trd-sw') +
        '<span class="trd-t"><strong>' + esc(qs.name) + '</strong><small>' + sub + '</small></span><span class="trd-yd">' + (en ? fmtYd(y.perSlot[k] || 0) : '') + '</span></button>';
    }).join('');
  };
  P.fabricShown = function (f) {
    var s = this.state;
    if (s.fam !== 'all' && !(s.fam === 'solid' ? f.solid : f.fam === s.fam)) return false;
    if (s.hol && f.tags.indexOf(s.hol) < 0) return false;
    var words = norm(s.query).split(/\s+/).filter(Boolean);
    return words.every(function (w) { return f.hay.indexOf(w) > -1; });
  };
  P.renderPicker = function () {
    var s = this.state, hits = 0, self = this;
    var cur = this.storedKey(s.active);
    this.q('[data-trd-picker-h]').innerHTML = 'Choose fabric for <b>' + esc(this.slotName(s.active)) + '</b>';
    this.app.querySelectorAll('[data-trd-fabric]').forEach(function (el) {
      var f = self.byKey[el.getAttribute('data-trd-fabric')];
      el.hidden = !self.fabricShown(f);
      if (!el.hidden) hits++;
      el.setAttribute('aria-pressed', String(f.key === cur));
    });
    this.q('[data-trd-nohits]').hidden = hits > 0;
    this.app.querySelectorAll('[data-trd-fam]').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-trd-fam') === s.fam)); });
    this.app.querySelectorAll('[data-trd-holiday]').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-trd-holiday') === s.hol)); });
  };
  P.renderList = function () {
    var self = this, y = this.yardage(), buy = y.buy, spec = this.spec;
    var short = this.shortages(buy);
    var step = this.cfg.cartMode === 'yards' ? 1 : 4;
    this.q('[data-trd-list-for]').textContent = spec.sizeText.call(this);
    this.q('[data-trd-size]').innerHTML = spec.sizeHead.call(this);
    var keys = Object.keys(buy).sort(function (a, b) { return buy[b] - buy[a]; });
    var tot = 0, yd = 0;
    this.q('[data-trd-list]').innerHTML = keys.map(function (k) {
      var f = self.byKey[k], cost = buy[k] * f.pricePerYard, isShort = short.indexOf(k) > -1;
      tot += cost; yd += buy[k];
      return '<tr' + (isShort ? ' class="trd-short"' : '') + '><td class="trd-mini-td">' + self.swatch(k, 'trd-mini') + '</td><td><a class="trd-nm" href="' + esc(f.url) + '">' + esc(f.name) + '</a><div class="trd-sk">' + esc([f.vendor, f.sku].filter(Boolean).join(' · ')) + '</div>' +
        '<div class="trd-sk">For: ' + esc(y.uses[k].join(', ')) + '</div>' +
        (isShort ? '<div class="trd-sk trd-sk--warn">Only ' + fmtYd(f.stockYards, 4) + ' in stock</div>' : '') +
        '</td><td class="trd-r">' + fmtYd(buy[k], step) + '</td><td class="trd-r">' + self.money(cost) + '</td></tr>';
    }).join('');
    this.q('[data-trd-tot-yd]').textContent = keys.length + ' fabrics · ' + fmtYd(yd, step);
    this.q('[data-trd-tot]').textContent = this.money(tot);
    var add = this.q('[data-trd-add]'), warn = this.q('[data-trd-warn]');
    if (short.length) {
      warn.hidden = false;
      warn.textContent = 'Not enough in stock: ' + short.map(function (k) { return self.byKey[k].name + ' (' + y.uses[k].join(', ') + ')'; }).join('; ') + '. Choose another fabric for those parts to continue.';
      add.disabled = true;
      add.textContent = 'Choose fabrics that are in stock';
    } else {
      warn.hidden = true;
      add.disabled = false;
      add.textContent = 'Add all ' + keys.length + ' to cart · ' + this.money(tot);
    }
    var extra = spec.extraNote ? spec.extraNote.call(this) : '';
    var ex = this.q('[data-trd-extra]');
    ex.hidden = !extra; ex.textContent = extra;
    this.q('[data-trd-fine]').textContent = 'Yardage includes ¼″ seams, about ' + (Number(this.cfg.wastePercent) || 0) + '% extra for trimming the pieced parts and a ' +
      (Number(this.cfg.usableWidth) || 40) + '″ usable width, rounded up to the next ' + (step === 1 ? 'yard' : '¼ yard') + '. ' + spec.fineText.call(this) +
      (step === 1 ? '' : ' Each fabric is cut in one continuous piece from the bolt.');
  };
  P.renderControls = function () {
    var s = this.state;
    this.app.querySelectorAll('[data-trd-view]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-trd-view') === s.view)); });
    this.app.querySelectorAll('[data-trd-opt]').forEach(function (el) { el.value = String(s.opt[el.getAttribute('data-trd-opt')]); });
  };
  P.renderAll = function () {
    this.renderBlocks(); this.renderStage(); this.renderSlots(); this.renderPicker(); this.renderList(); this.renderControls();
    this.syncUrl();
  };

  // ---------- actions ----------
  P.fallback = function () {
    if (!this.slotEnabled(this.state.active)) this.state.active = 'b:' + this.design().slots[0].id;
  };
  P.setActive = function (k) {
    if (!this.slotEnabled(k)) return;
    this.state.active = k; this.state.hover = null;
    this.renderStage(); this.renderSlots(); this.renderPicker();
  };
  P.setFabric = function (key) {
    var p = this.state.active.split(':');
    if (p[0] === 'b') this.state.fab[this.design().id][p[1]] = key; else this.state.q[p[1]] = key;
    this.state.hover = null;
    this.renderAll();
  };
  P.pools = function () {
    var self = this;
    function pool(fn) { var p = self.fabrics.filter(fn); return p.length ? p : self.fabrics; }
    // "Surprise me" stays inside the chosen holiday, if there are enough fabrics for it.
    var hol = this.state.hol, base = function (f) { return true; };
    if (hol && this.fabrics.filter(function (f) { return f.tags.indexOf(hol) > -1; }).length >= 3) base = function (f) { return f.tags.indexOf(hol) > -1; };
    return {
      light: pool(function (f) { return base(f) && f.fam === 'light'; }),
      dark: pool(function (f) { return base(f) && /blue|purple|grey|brown|green/.test(f.fam); }),
      mid: pool(function (f) { return base(f) && f.fam !== 'light'; })
    };
  };
  P.surprise = function () {
    var des = this.design(), used = {}, s = this.state, pools = this.pools();
    function take(p) {
      var f, t = 0;
      do { f = p[Math.floor(Math.random() * p.length)]; t++; } while (used[f.key] && t < 40);
      used[f.key] = true; return f.key;
    }
    function any(arr, dflt) { return arr.length ? arr[Math.floor(Math.random() * arr.length)] : dflt; }
    des.slots.forEach(function (sl) {
      s.fab[des.id][sl.id] = take(sl.role === 'light' ? pools.light : sl.role === 'dark' ? pools.dark : pools.mid);
    });
    var accents = des.slots.filter(function (sl) { return sl.role !== 'light'; }).map(function (sl) { return s.fab[des.id][sl.id]; });
    var lights = des.slots.filter(function (sl) { return sl.role === 'light'; }).map(function (sl) { return s.fab[des.id][sl.id]; });
    this.spec.surpriseFinish.call(this, { take: take, any: any, accents: accents, lights: lights, pools: pools });
    this.renderAll();
  };
  P.reset = function () {
    var keep = { design: this.state.design, view: this.state.view, opt: this.state.opt, hol: this.state.hol };
    this.state = this.initialState();
    this.state.design = keep.design; this.state.view = keep.view; this.state.opt = keep.opt; this.state.hol = keep.hol;
    var d = this.design();
    this.state.q = this.finishDefaults(d, this.state.fab[d.id]);
    this.state.active = 'b:' + (d.slots[1] || d.slots[0]).id;
    this.fallback();
    var search = this.q('[data-trd-search]'); if (search) search.value = '';
    this.renderAll();
  };
  P.message = function (html, isError) {
    var m = this.q('[data-trd-msg]');
    m.hidden = false;
    m.className = 'trd-msg' + (isError ? ' trd-msg--err' : '');
    m.innerHTML = html;
  };
  P.cartItems = function () {
    var self = this, y = this.yardage(), des = this.design(), mode = this.cfg.cartMode, label = this.spec.sizeText.call(this);
    return Object.keys(y.buy).map(function (k) {
      var f = self.byKey[k], yd = y.buy[k], props = {};
      props[self.spec.propLabel] = des.name + ', ' + label;
      props['Used for'] = y.uses[k].join(', ');
      return {
        id: f.variantId,
        key: k,
        quantity: mode === 'quarter_units' ? Math.round(yd * 4) : Math.ceil(yd - 1e-9),
        yards: yd,
        properties: props
      };
    });
  };
  // Measura line: one continuous piece (quantity 1) of the full length, priced per yard by Measura
  // from these properties. Format observed on the demo store, 2026-09-25. Re-test after Measura updates.
  P.measuraLine = function (item, n) {
    var f = this.byKey[item.key], yd = item.yards;
    var unitPrice = this.money(f.pricePerYard) + ' / yd';
    var props = {
      'Net length': yd + ' yd',
      'Unit price': unitPrice,
      '_measura_data': JSON.stringify({
        p: {}, pi: 0, u: unitPrice,
        m: { d: [{ v: yd, u: 'yd' }] },
        measurement: { type: 'length', dimensions: [{ unit: 'yd', value: yd }] },
        um: { v: 1, u: 'yd' }
      }),
      '_measura_item_id': String(Date.now() * 1000 + n * 97 + Math.floor(Math.random() * 97))
    };
    Object.keys(item.properties).forEach(function (k) { props[k] = item.properties[k]; });
    return { id: item.id, quantity: 1, properties: props };
  };
  P.linkList = function (items) {
    var self = this;
    return '<ul class="trd-links">' + items.map(function (i) {
      var f = self.byKey[i.key];
      return '<li><a href="' + esc(f.url) + '" target="_blank" rel="noopener">' + esc(f.name) + (f.sku ? ' <span class="trd-sk">' + esc(f.sku) + '</span>' : '') + '</a><b>' + fmtYd(i.yards, 4) + '</b></li>';
    }).join('') + '</ul>';
  };
  P.addToCart = function () {
    var self = this, btn = this.q('[data-trd-add]'), ev0 = this.spec.event;
    var items = this.cartItems(), lines;
    if (this.cfg.cartMode === 'event') {
      // Other code can take over by calling preventDefault() on this event.
      var ev = new CustomEvent(ev0 + ':add', {
        bubbles: true, cancelable: true,
        detail: { items: items, design: this.design().id, size: this.spec.sizeText.call(this), shareUrl: this.shareUrl() }
      });
      this.root.dispatchEvent(ev);
      if (ev.defaultPrevented) { this.message('Adding your fabrics…'); return; }
      lines = items.map(function (i, n) { return self.measuraLine(i, n); });
    } else {
      lines = items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: i.properties }; });
    }
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch(this.cfg.cartAddUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (res) {
      return res.json().then(function (body) { return { ok: res.ok, body: body }; });
    }).then(function (r) {
      if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'The cart didn’t accept these fabrics.');
      document.dispatchEvent(new CustomEvent(ev0 + ':added', { detail: { items: items } }));
      if (self.cfg.afterAdd === 'cart_page') { window.location.href = self.cfg.cartUrl || '/cart'; return; }
      self.message('Added ' + items.length + ' fabrics to your cart. <a href="' + esc(self.cfg.cartUrl || '/cart') + '">View cart</a>');
      btn.disabled = false; btn.textContent = label;
    }).catch(function (err) {
      self.message('<p class="trd-msg-p">' + esc(err.message) + ' Nothing was added. Please try again, or add each fabric from its own page with the amount shown:</p>' +
        self.linkList(items), true);
      btn.disabled = false; btn.textContent = label;
    });
  };
  P.copyLink = function () {
    var url = this.shareUrl(), self = this, btn = this.q('[data-trd-share]');
    function done() { btn.textContent = 'Link copied'; setTimeout(function () { btn.textContent = 'Copy link to this design'; }, 2000); }
    function fallback() { self.message('Copy this link: <input class="trd-search" readonly value="' + esc(url) + '" onclick="this.select()">'); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, fallback);
    else fallback();
  };

  P.bind = function () {
    var self = this, app = this.app;
    app.addEventListener('click', function (e) {
      var t = e.target, el;
      if ((el = t.closest('[data-trd-design]'))) {
        self.state.design = el.getAttribute('data-trd-design');
        var d = self.design(); self.state.active = 'b:' + (d.slots[1] || d.slots[0]).id; self.state.hover = null;
        self.renderAll(); return;
      }
      if ((el = t.closest('[data-trd-slot]'))) {
        self.setActive(el.getAttribute('data-trd-slot'));
        if (window.innerWidth < 990) self.q('.trd-picker').scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if ((el = t.closest('[data-trd-canvas] [data-slot]'))) { self.setActive(el.getAttribute('data-slot')); return; }
      if ((el = t.closest('[data-trd-fabric]'))) { self.setFabric(el.getAttribute('data-trd-fabric')); return; }
      if ((el = t.closest('[data-trd-fam]'))) { self.state.fam = el.getAttribute('data-trd-fam'); self.renderPicker(); return; }
      if ((el = t.closest('[data-trd-holiday]'))) {
        var tag = el.getAttribute('data-trd-holiday');
        self.state.hol = self.state.hol === tag ? '' : tag; // tap again to turn it off
        self.renderPicker(); self.syncUrl(); return;
      }
      if ((el = t.closest('[data-trd-view]'))) { self.state.view = el.getAttribute('data-trd-view'); self.renderAll(); return; }
      if (t.closest('[data-trd-surprise]')) { self.surprise(); return; }
      if (t.closest('[data-trd-reset]')) { self.reset(); return; }
      if (t.closest('[data-trd-add]')) { self.addToCart(); return; }
      if (t.closest('[data-trd-share]')) { self.copyLink(); return; }
    });
    app.addEventListener('change', function (e) {
      var opt = e.target.getAttribute('data-trd-opt');
      if (!opt) return;
      self.state.opt[opt] = e.target.value;
      self.fallback();
      self.renderAll();
    });
    app.addEventListener('input', function (e) {
      if (e.target.hasAttribute('data-trd-search')) { self.state.query = e.target.value; self.renderPicker(); }
    });
    var grid = this.q('[data-trd-grid]');
    grid.addEventListener('mouseover', function (e) {
      var f = e.target.closest('[data-trd-fabric]');
      if (f && self.state.hover !== f.getAttribute('data-trd-fabric')) { self.state.hover = f.getAttribute('data-trd-fabric'); self.renderStage(); }
    });
    grid.addEventListener('mouseleave', function () { if (self.state.hover) { self.state.hover = null; self.renderStage(); } });
  };
  // ===================== end of shared core =====================

  // ===================== table runner & placemat designer =====================
  // A 12" wide pieced center made of repeats that run along the runner (x = along, y = across).
  // Placemats: one 12" pieced section plus a plain panel that brings the mat to 18" long.
  var PM_LEN = 18;
  var LENGTHS = { '36': 'short runner', '54': 'medium runner', '72': 'long runner', '90': 'banquet runner', pm4: 'placemats, set of 4', pm6: 'placemats, set of 6' };
  var BUILTIN = [{"id":"flying-geese","aliases":["geese"],"name":"Flying Geese","skill":"Beginner+","geometry":{"height":12,"unit":6,"slots":[{"id":"sky","name":"Sky (background)","role":"light"},{"id":"geeseA","name":"Geese A","role":"any"},{"id":"geeseB","name":"Geese B","role":"dark"}],"repeats":[{"pieces":[{"s":"geeseA","p":[[0,0],[3,3],[0,6]]},{"s":"sky","p":[[0,0],[3,0],[3,3]]},{"s":"sky","p":[[0,6],[3,3],[3,6]]},{"s":"geeseA","p":[[3,6],[3,12],[0,9]]},{"s":"sky","p":[[0,6],[3,6],[0,9]]},{"s":"sky","p":[[0,9],[3,12],[0,12]]},{"s":"geeseB","p":[[3,0],[6,3],[3,6]]},{"s":"sky","p":[[3,0],[6,0],[6,3]]},{"s":"sky","p":[[3,6],[6,3],[6,6]]},{"s":"geeseB","p":[[6,6],[6,12],[3,9]]},{"s":"sky","p":[[3,6],[6,6],[3,9]]},{"s":"sky","p":[[3,9],[6,12],[3,12]]}]}]},"defaults":{"sky":"CRM2952","geeseA":"RED0315","geeseB":"BLUE5089","_panel":"CRM2952","_border":"BLUE5089","_binding":"RED6601","_backing":"CRM2952"}},{"id":"chevron","aliases":["chevron"],"name":"Chevron","skill":"Beginner","geometry":{"height":12,"unit":6,"slots":[{"id":"bg","name":"Background","role":"light"},{"id":"zigA","name":"Zigzag A","role":"any"},{"id":"zigB","name":"Zigzag B","role":"any"}],"repeats":[{"pieces":[{"s":"bg","p":[[0,0],[3,0],[0,3]]},{"s":"zigA","p":[[3,0],[3,3],[0,3]]},{"s":"bg","p":[[3,0],[6,0],[6,3]]},{"s":"zigA","p":[[3,0],[6,3],[3,3]]},{"s":"zigA","p":[[0,3],[3,3],[0,6]]},{"s":"bg","p":[[3,3],[3,6],[0,6]]},{"s":"zigA","p":[[3,3],[6,3],[6,6]]},{"s":"bg","p":[[3,3],[6,6],[3,6]]},{"s":"bg","p":[[0,6],[3,6],[0,9]]},{"s":"zigB","p":[[3,6],[3,9],[0,9]]},{"s":"bg","p":[[3,6],[6,6],[6,9]]},{"s":"zigB","p":[[3,6],[6,9],[3,9]]},{"s":"zigB","p":[[0,9],[3,9],[0,12]]},{"s":"bg","p":[[3,9],[3,12],[0,12]]},{"s":"zigB","p":[[3,9],[6,9],[6,12]]},{"s":"bg","p":[[3,9],[6,12],[3,12]]}]}]},"defaults":{"bg":"CRM2953","zigA":"OR3064","zigB":"GOLD4603","_panel":"CRM2952","_border":"BLUE5089","_binding":"RED6601","_backing":"CRM2952"}},{"id":"nine-patch","aliases":["nine"],"name":"Nine Patch","skill":"Beginner","geometry":{"height":12,"unit":12,"slots":[{"id":"patch","name":"Patches","role":"any"},{"id":"bg","name":"Background","role":"light"},{"id":"feature","name":"Feature squares","role":"dark"}],"repeats":[{"pieces":[{"s":"patch","p":[[0,0],[4,0],[4,4],[0,4]]},{"s":"bg","p":[[4,0],[8,0],[8,4],[4,4]]},{"s":"patch","p":[[8,0],[12,0],[12,4],[8,4]]},{"s":"bg","p":[[0,4],[4,4],[4,8],[0,8]]},{"s":"patch","p":[[4,4],[8,4],[8,8],[4,8]]},{"s":"bg","p":[[8,4],[12,4],[12,8],[8,8]]},{"s":"patch","p":[[0,8],[4,8],[4,12],[0,12]]},{"s":"bg","p":[[4,8],[8,8],[8,12],[4,12]]},{"s":"patch","p":[[8,8],[12,8],[12,12],[8,12]]}]},{"pieces":[{"s":"feature","p":[[0,0],[12,0],[12,12],[0,12]]}]}]},"defaults":{"patch":"BLUE6341","bg":"CRM3227","feature":"BLUE6524","_panel":"CRM2952","_border":"BLUE5089","_binding":"RED6601","_backing":"CRM2952"}},{"id":"square-in-a-square","aliases":["sqsq"],"name":"Square in a Square","skill":"Confident beginner","geometry":{"height":12,"unit":12,"slots":[{"id":"center","name":"Center squares","role":"any"},{"id":"ringA","name":"Diamonds A","role":"any"},{"id":"ringB","name":"Diamonds B","role":"dark"},{"id":"bg","name":"Corners (background)","role":"light"}],"repeats":[{"pieces":[{"s":"center","p":[[3,3],[9,3],[9,9],[3,9]]},{"s":"ringA","p":[[3,3],[6,0],[9,3]]},{"s":"ringA","p":[[9,3],[12,6],[9,9]]},{"s":"ringA","p":[[9,9],[6,12],[3,9]]},{"s":"ringA","p":[[3,9],[0,6],[3,3]]},{"s":"bg","p":[[0,0],[6,0],[0,6]]},{"s":"bg","p":[[6,0],[12,0],[12,6]]},{"s":"bg","p":[[12,6],[12,12],[6,12]]},{"s":"bg","p":[[6,12],[0,12],[0,6]]}]},{"pieces":[{"s":"center","p":[[3,3],[9,3],[9,9],[3,9]]},{"s":"ringB","p":[[3,3],[6,0],[9,3]]},{"s":"ringB","p":[[9,3],[12,6],[9,9]]},{"s":"ringB","p":[[9,9],[6,12],[3,9]]},{"s":"ringB","p":[[3,9],[0,6],[3,3]]},{"s":"bg","p":[[0,0],[6,0],[0,6]]},{"s":"bg","p":[[6,0],[12,0],[12,6]]},{"s":"bg","p":[[12,6],[12,12],[6,12]]},{"s":"bg","p":[[6,12],[0,12],[0,6]]}]}]},"defaults":{"center":"GOLD3269","ringA":"RED6530","ringB":"GRN2311","bg":"CRM7782","_panel":"CRM2952","_border":"BLUE5089","_binding":"RED6601","_backing":"CRM2952"}},{"id":"rail-fence","aliases":["rail"],"name":"Rail Fence","skill":"Beginner","geometry":{"height":12,"unit":12,"slots":[{"id":"rail1","name":"Rail 1 (outer)","role":"any"},{"id":"rail2","name":"Rail 2 (middle)","role":"light"},{"id":"rail3","name":"Rail 3 (outer)","role":"dark"}],"repeats":[{"pieces":[{"s":"rail1","p":[[0,0],[12,0],[12,4],[0,4]]},{"s":"rail2","p":[[0,4],[12,4],[12,8],[0,8]]},{"s":"rail3","p":[[0,8],[12,8],[12,12],[0,12]]}]},{"pieces":[{"s":"rail1","p":[[0,0],[4,0],[4,12],[0,12]]},{"s":"rail2","p":[[4,0],[8,0],[8,12],[4,12]]},{"s":"rail3","p":[[8,0],[12,0],[12,12],[8,12]]}]}]},"defaults":{"rail1":"TAN0301","rail2":"OR3113","rail3":"BR3428","_panel":"CRM2952","_border":"BLUE5089","_binding":"RED6601","_backing":"CRM2952"}}];

  function prepGeometry(g) {
    g = parseJson(g);
    if (!g) return null;
    var slots = normSlots(g.slots);
    if (!slots || !Array.isArray(g.repeats) || !g.repeats.length) return null;
    var reps = g.repeats.map(function (r) { return r && r.pieces; });
    if (!reps.every(validPieces)) return null;
    return { H: Number(g.height) || 12, unit: Number(g.unit) || 12, slots: slots, repeats: reps };
  }

  P.rep = function (des, i) { return des.repeats[i % des.repeats.length]; };
  P.runnerDims = function () {
    var d = this.design(), len = String(this.opt('len')), bw = Number(this.opt('border')) || 0, H = d.H;
    if (len.indexOf('pm') === 0) {
      var n = Math.max(1, Math.round(12 / d.unit)), Lc = n * d.unit, panel = Math.max(0, PM_LEN - 2 * bw - Lc), Li = Lc + panel;
      return { mat: true, count: Number(len.slice(2)) || 4, n: n, Lc: Lc, bw: bw, panel: panel, Li: Li, H: H, L: Li + 2 * bw, W: H + 2 * bw, label: LENGTHS[len] };
    }
    var n2 = Math.max(2, Math.round((Number(len) - 2 * bw) / d.unit)), Li2 = n2 * d.unit;
    return { mat: false, count: 1, n: n2, Lc: Li2, bw: bw, panel: 0, Li: Li2, H: H, L: Li2 + 2 * bw, W: H + 2 * bw, label: LENGTHS[len] || 'runner' };
  };
  P.dash = function (sw, extra) { return 'fill="none" stroke="var(--trd-thread)" stroke-width="' + sw + '" stroke-dasharray="1 .6" pointer-events="none"' + (extra || ''); };
  // Close-up: 24" of the pieced center, so alternating repeats show, with ruler numbers.
  P.closeSVG = function () {
    var self = this, d = this.design(), H = d.H, reps = Math.ceil(24 / d.unit), Lc = reps * d.unit, m = 1.5, best = {}, over = '';
    var o = '<svg viewBox="' + (-m) + ' ' + (-m) + ' ' + (Lc + 2 * m) + ' ' + (H + 2 * m) + '" role="img" aria-label="' + esc(d.name + ' close-up, first ' + Lc + ' inches') + '">';
    o += this.mat(-m, -m, Lc + 2 * m, H + 2 * m, 0.5, 1);
    for (var i = 0; i <= Lc; i += 2) o += '<text x="' + i + '" y="' + (-m + 0.62) + '" font-size=".38" ' + LABEL + '>' + i + '</text>';
    for (var j = 0; j <= H; j += 2) o += '<text x="' + (-m + 0.5) + '" y="' + (j + 0.13) + '" font-size=".38" ' + LABEL + '>' + j + '</text>';
    o += '<rect x="-.06" y="-.06" width="' + (Lc + 0.12) + '" height="' + (H + 0.12) + '" fill="rgba(0,0,0,.25)"/>';
    for (var k = 0; k < reps; k++) {
      var pcs = this.rep(d, k), g = this.piecesSVG(pcs, k * d.unit, 0, { click: true });
      o += g.body; over += g.sel;
      pcs.forEach(function (pc) {
        var a = area(pc.p);
        if (!best[pc.s] || a > best[pc.s].a) { var c = centroid(pc.p); best[pc.s] = { a: a, c: [c[0] + k * d.unit, c[1]] }; }
      });
    }
    o += over;
    d.slots.forEach(function (sl, n) { if (best[sl.id]) o += self.badge(best[sl.id].c[0], best[sl.id].c[1], n + 1, 0.42); });
    return o + '</svg>';
  };
  P.wholeSVG = function () {
    var d = this.design(), dm = this.dims(), s = this.state, m = Math.max(3, dm.W * 0.25), over = '';
    var X0 = -m, Y0 = -m, VW = dm.L + 2 * m, VH = dm.W + 2 * m, fz = m * 0.3;
    var o = '<svg viewBox="' + X0 + ' ' + Y0 + ' ' + VW + ' ' + VH + '" role="img" aria-label="' + esc(d.name + ' ' + dm.label + ', ' + dm.L + ' by ' + dm.W + ' inches') + '">';
    o += this.mat(X0, Y0, VW, VH, 1, 6);
    o += '<rect x="-.3" y="-.3" width="' + (dm.L + 0.6) + '" height="' + (dm.W + 0.6) + '" fill="rgba(0,0,0,.28)"/>';
    if (dm.bw > 0) o += '<rect x="0" y="0" width="' + dm.L + '" height="' + dm.W + '" fill="' + this.fill(this.keyFor('q:border')) + '" data-slot="q:border"/>';
    for (var i = 0; i < dm.n; i++) {
      var g = this.piecesSVG(this.rep(d, i), dm.bw + i * d.unit, dm.bw, { click: true });
      o += g.body; over += g.sel;
    }
    o += over;
    if (dm.panel > 0) o += '<rect x="' + (dm.bw + dm.Lc) + '" y="' + dm.bw + '" width="' + dm.panel + '" height="' + dm.H + '" fill="' + this.fill(this.keyFor('q:panel')) + '" stroke="' + SEAM + '" stroke-width=".04" data-slot="q:panel"/>';
    var t = 0.375;
    if (this.opt('finish') === 'bind') o += '<path fill-rule="evenodd" d="M0 0H' + dm.L + 'V' + dm.W + 'H0Z M' + t + ' ' + t + 'V' + (dm.W - t) + 'H' + (dm.L - t) + 'V' + t + 'Z" fill="' + this.fill(this.keyFor('q:binding')) + '" data-slot="q:binding"/>';
    if (s.active === 'q:border' && dm.bw > 0) o += '<rect x="' + dm.bw / 2 + '" y="' + dm.bw / 2 + '" width="' + (dm.L - dm.bw) + '" height="' + (dm.W - dm.bw) + '" ' + this.dash(dm.bw * 0.9, ' stroke-opacity=".35"') + '/>';
    if (s.active === 'q:panel' && dm.panel > 0) o += '<rect x="' + (dm.bw + dm.Lc) + '" y="' + dm.bw + '" width="' + dm.panel + '" height="' + dm.H + '" ' + this.dash(0.2) + '/>';
    if (s.active === 'q:binding') o += '<rect x="0" y="0" width="' + dm.L + '" height="' + dm.W + '" ' + this.dash(0.3) + '/>';
    o += '<text x="' + dm.L / 2 + '" y="' + (-m * 0.3) + '" font-size="' + fz + '" ' + LABEL + '>' + dm.L + '″</text>';
    o += '<text x="' + (-m * 0.45) + '" y="' + dm.W / 2 + '" font-size="' + fz + '" ' + LABEL + ' transform="rotate(-90 ' + (-m * 0.45) + ' ' + dm.W / 2 + ')">' + dm.W + '″</text>';
    if (dm.mat) o += '<text x="' + (dm.L + m * 0.5) + '" y="' + (dm.W / 2 + m * 0.1) + '" font-size="' + fz + '" ' + LABEL + '>×' + dm.count + '</text>';
    return o + '</svg>';
  };

  var SPEC = {
    noun: 'table runner', param: 'runner', event: 'runnerdesigner', propLabel: 'Runner design',
    designsLabel: 'Runner designs', qTitle: 'Runner finishing',
    hint: 'The pieced center is 12″ wide. Click any patch to choose its fabric. Prints are shown at approximate real size. Screen colors vary from the actual fabric.',
    views: [['close', 'Close-up'], ['whole', 'Whole runner']], defaultView: 'whole',
    builtin: BUILTIN, prepGeometry: prepGeometry,
    options: [
      { id: 'len', label: 'Size', cfgKey: 'defaultSize', dflt: '54', opts: [['36', 'Short (about 36″)'], ['54', 'Medium (about 54″)'], ['72', 'Long (about 72″)'], ['90', 'Banquet (about 90″)'], ['pm4', 'Placemats, set of 4'], ['pm6', 'Placemats, set of 6']] },
      { id: 'border', label: 'Border', dflt: '2', opts: [['0', 'None'], ['2', '2″'], ['3', '3″']] },
      { id: 'back', label: 'Backing', dflt: '1', opts: [['1', 'Include'], ['0', 'I have my own']] },
      { id: 'finish', label: 'Finish', dflt: 'bind', opts: [['bind', 'Binding'], ['pillow', 'Pillowcase (no binding)']] }
    ],
    qslots: [
      { id: 'panel', name: 'Placemat panel', sku: 'CRM2952', from: 'light', off: 'Placemats only', on: function () { return this.dims().panel > 0; } },
      { id: 'border', name: 'Border', sku: 'BLUE5089', from: 'dark', off: 'Border is off', on: function () { return this.dims().bw > 0; } },
      { id: 'binding', name: 'Binding', sku: 'RED6601', from: 'second', off: 'Pillowcase finish', on: function () { return this.opt('finish') === 'bind'; } },
      { id: 'backing', name: 'Backing', sku: 'CRM2952', from: 'light', off: 'Using your own', on: function () { return this.opt('back') === '1'; } }
    ],
    dims: function () { return this.runnerDims(); },
    yardage: function (y) {
      var dm = this.dims(), d = this.design(), N = dm.count, WOF = y.WOF, cut = {};
      for (var i = 0; i < dm.n; i++) this.rep(d, i).forEach(function (pc) { cut[pc.s] = (cut[pc.s] || 0) + cutArea(pc.p); });
      d.slots.forEach(function (sl) { if (cut[sl.id]) y.pieced('b:' + sl.id, N * cut[sl.id]); });
      if (dm.panel > 0) { // panels cut side by side from one strip the height of the center
        var fit = Math.max(1, Math.floor(WOF / (dm.panel + 0.5)));
        y.put('q:panel', Math.ceil(N / fit) * (dm.H + 0.5) / 36);
      }
      if (dm.bw > 0) y.put('q:border', y.strips(N * (2 * dm.Li + 2 * dm.W + 10), dm.bw + 0.5));
      if (this.opt('finish') === 'bind') y.put('q:binding', y.strips(N * (2 * (dm.L + dm.W) + 15), 2.5));
      if (this.opt('back') === '1') {
        // backings 4" larger, laid side by side across the fabric width; wider than the fabric is pieced
        var bl = dm.L + 4, bwid = dm.W + 4;
        var perRow = Math.max(1, Math.floor(WOF / bwid)), rows = bwid <= WOF ? Math.ceil(N / perRow) : N * Math.ceil(bwid / WOF);
        y.put('q:backing', rows * bl / 36);
      }
    },
    render: function (view) { return view === 'close' ? this.closeSVG() : this.wholeSVG(); },
    miniSVG: function (d) {
      var f = this.state.fab[d.id], reps = Math.ceil(24 / d.unit), Lc = reps * d.unit;
      var o = '<svg viewBox="0 0 ' + Lc + ' ' + d.H + '" aria-hidden="true" focusable="false">';
      for (var i = 0; i < reps; i++) o += this.piecesSVG(this.rep(d, i), i * d.unit, 0, { fabOf: function (sid) { return f[sid]; } }).body;
      return o + '</svg>';
    },
    sizeText: function () {
      var dm = this.dims();
      return dm.L + '″ × ' + dm.W + '″ ' + dm.label.replace('placemats, set of ', 'placemats ×');
    },
    sizeHead: function () {
      var dm = this.dims();
      return '<b>' + dm.L + '″ × ' + dm.W + '″</b> ' + (dm.mat ? 'placemats · set of ' + dm.count : dm.label + ' · ' + dm.n + ' repeats');
    },
    fineText: function () {
      return 'Border and binding are cut as width-of-fabric strips (binding 2½″). Backing is 4″ larger than each runner or placemat. Placemats are 18″ long: one 12″ pieced section plus a plain panel. Batting is not included.';
    },
    surpriseFinish: function (h) {
      var s = this.state;
      s.q.border = h.any(h.accents, s.q.border);
      s.q.binding = h.any(h.accents, s.q.binding);
      s.q.panel = h.any(h.lights, h.take(h.pools.light));
      s.q.backing = h.take(h.pools.light);
    }
  };

  // ---------- boot ----------
  function init(scope) {
    (scope || document).querySelectorAll('[data-table-runner-designer]').forEach(function (root) {
      if (root.__trd) return;
      root.__trd = new Designer(root, SPEC);
    });
  }
  window.TableRunnerDesigner = Designer;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor: re-run when the section is added or its settings change.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
